import { type FC, type ReactNode } from "react";

import { faChevronLeft } from "@fortawesome/pro-duotone-svg-icons/faChevronLeft";
import { faFile } from "@fortawesome/pro-duotone-svg-icons/faFile";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

// One page opened from a page tag: a way back, "Page N" and its file, the
// letter it belongs to, then the page itself.
export const PageView: FC<{
  backLabel: string;
  onBack(): void;
  number: number;
  filename?: string;
  context?: ReactNode;
  children: ReactNode;
}> = ({ backLabel, onBack, number, filename, context, children }) => (
  <div className="flex min-h-0 min-w-0 flex-1 flex-col rounded-lg border border-slate-200 bg-slate-100 px-[18px] pt-3 pb-3.5">
    <div className="flex items-center gap-2.5">
      <button
        type="button"
        onClick={onBack}
        className="inline-flex cursor-pointer items-center gap-1 text-xs font-semibold text-indigo-600 hover:text-indigo-500"
      >
        <FontAwesomeIcon icon={faChevronLeft} size="xs" /> {backLabel}
      </button>
      <span className="flex-1" />
      <span className="inline-flex items-center gap-1.5 text-xs font-bold text-slate-700">
        <FontAwesomeIcon icon={faFile} className="text-slate-400" /> Page{" "}
        {number}
      </span>
      {filename && (
        <span className="truncate text-[11px] text-slate-500">{filename}</span>
      )}
    </div>
    {context && (
      <div className="mt-[7px] truncate text-[11px] text-slate-500">
        {context}
      </div>
    )}
    <div className="mt-2.5 min-h-0 flex-1 overflow-y-auto [&_img]:w-full">
      {children}
    </div>
  </div>
);

// "In <letter> · pp. a–b": the letter's title stands out.
export const PageViewLetter: FC<{ children: ReactNode; pages: string }> = ({
  children,
  pages,
}) => (
  <>
    In <span className="font-semibold text-slate-700">{children}</span> ·{" "}
    {pages}
  </>
);
